/**
 * The script that starts the built app: Vite names it by the hash of its
 * content, so every build has another one. The dev server has none.
 */
const ENTRY_SCRIPT_SELECTOR = 'script[type="module"][src^="/assets/"]';

function findEntryScript(root: ParentNode): string | null {
  return root.querySelector(ENTRY_SCRIPT_SELECTOR)?.getAttribute('src') ?? null;
}

/** The entry script the open page was loaded with; `null` when the page has none (the dev server). */
export function readEntryScriptOfPage(): string | null {
  return findEntryScript(document);
}

/** The entry script of an `index.html` body; `null` for anything else (e.g. an error page of a proxy). */
export function readEntryScriptFromHtml(html: string): string | null {
  return findEntryScript(new DOMParser().parseFromString(html, 'text/html'));
}
